import { anyAssetConstants } from '@chainflip/utils/chainflip';
import HighlightableAddress from '@/shared/components/HighlightableAddress';
import CopyButton from '@/shared/components/molecules/CopyButton';
import { Tooltip } from '@/shared/components/molecules/Tooltip';
import { type OpenChannelFragment as Channel } from '@/shared/graphql/generated/explorer/graphql';
import { type SwapRequestOverviewFragment as SwapRequest } from '@/shared/graphql/generated/reporting/graphql';
import SendIcon from '@/shared/icons/flip-ui-kit/small/Send';
import ShieldTickIcon from '@/shared/icons/flip-ui-kit/small/ShieldTick';

export const Addresses = (props: { channel: Channel } | { swap: SwapRequest }) => {
  let destinationAddress;
  let destinationChain;
  let refundAddress;
  let sourceChain;
  let isOnChain = false;

  if ('channel' in props) {
    destinationAddress = props.channel.destinationAddress;
    destinationChain = props.channel.destinationChain;
    refundAddress = props.channel.fokRefundAddress;
    sourceChain = props.channel.sourceChain;
  } else {
    isOnChain = props.swap.isOnChain;
    destinationAddress = props.swap.destinationAddress ?? '';
    destinationChain = isOnChain
      ? ('Chainflip' as const)
      : anyAssetConstants[props.swap.destAsset].chain;
    refundAddress = props.swap.refundAddress;
    sourceChain = anyAssetConstants[props.swap.sourceAsset].chain;
  }

  return (
    <div className="flex flex-col gap-y-1 whitespace-nowrap">
      {destinationAddress !== '' && (
        <div className="flex flex-row items-center space-x-1">
          <div title="Destination address">
            <SendIcon />
          </div>
          <Tooltip content={destinationAddress}>
            <HighlightableAddress chain={destinationChain} address={destinationAddress} />
          </Tooltip>
          <CopyButton textToCopy={destinationAddress} />
        </div>
      )}
      {refundAddress && !isOnChain && (
        <div className="flex flex-row items-center space-x-1">
          <div title="Refund address">
            <ShieldTickIcon />
          </div>
          <Tooltip content={refundAddress}>
            <HighlightableAddress chain={sourceChain} address={refundAddress} />
          </Tooltip>
          <CopyButton textToCopy={refundAddress} />
        </div>
      )}
    </div>
  );
};
